import { CardImagePizza } from "components/card/card_image/card_image_pizza/card_image_pizza";
import { CardHolder } from "components/card_holder/card_holder";
import { Footer } from "components/footer/footer";
import { NavigationBarHeader } from "components/navbar/navbar_pizza";
import { Loading } from "pages/loading/loading";
import Transitions from "utils/transition";
import { useStrapi } from "hooks/use-strapi";

export function PizzasDesserts() {
  const { data: pizzas, loading: loadingPizzas } =
    useStrapi("cg-pizza-desserts");
  const { data: etablissement, loading: loadingEtablissement } =
    useStrapi("cg-etablissement");

  if (loadingEtablissement || loadingPizzas) {
    return <Loading />;
  }

  return (
    <>
      <Transitions className="transition">
        <NavigationBarHeader />
        <CardHolder>
          {pizzas.map((value) => {
            return (
              <CardImagePizza data={value} key={value.id}></CardImagePizza>
            );
          })}
        </CardHolder>
        <Footer
          adress={etablissement.Adresse}
          contact={etablissement.Telephone}
        />
      </Transitions>
    </>
  );
}
